// export const url ='https://apitiendavirtual.emilima.com.pe/v1/'

//export const url ='https://apitiendavirtual.emilima.com.pe/v1/'
export const url ='https://apitiendavirtual.emilima.com.pe/v1/'